module.exports = __webpack_public_path__ + "static/suedbaden-56efe55d2de831b0733ab8fb44d16156.png";